'use strict';

var React = require('react');
//Components
var PersonalInfo = require('./PersonalInfo.jsx');
var ContactDetails = require('./ContactDetails.jsx');
var Tfn = require('../Common/Tfn.jsx');
var Occupation = require('./Occupation.jsx');
var SourceOfFund = require('./SourceOfFund.jsx');
var SourceOfWealth = require('./SourceOfWealth.jsx');
var Address = require('./Address.jsx');
var Residence = require('./Residence.jsx');
var TaxResidence = require('./TaxResidence.jsx');
var PowerOfAttorney = require('./PowerOfAttorney.jsx').default;
var AccountDesignation = require('./AccountDesignation.jsx').default;
var AustralianTaxResident = require('./AustralianTaxResident.jsx').default;

var YourDetailsConstants = require('../../constants/YourDetailsConstants.js');
var AppConstants = require('../../constants/ApplicationConstants.js');
var YesNoValues = AppConstants.YesNoValues;

//helpers
var Products = require('../../utils/Products.js');

var Investor = React.createClass({
  propTypes:{
    productId: React.PropTypes.number.isRequired,
    data: React.PropTypes.object.isRequired,
    tfnExemptionList: React.PropTypes.array.isRequired,
    titleList: React.PropTypes.object.isRequired,
    errorList: React.PropTypes.array.isRequired
  },
  getInitialState: function () {
    var isTrustee = this.props.accountType === AppConstants.AccountTypeCodes.TRUST;
    var isSMSF = this.props.accountType === AppConstants.AccountTypeCodes.SMSF;
    return {
      isAnnuity: Products.isAnnuity(this.props.productId),
      isTrustee: isTrustee,
      isSMSF: isSMSF,
      residenceCountryLabel: this.getResidenceCountryLabel(),
      taxCountryLabel: this.getTaxCountryLabel(isTrustee, isSMSF)
    }
  },
  getResidenceCountryLabel(){
    var label;
    switch(this.props.productId){
      case AppConstants.ProductIds.COMMINSURE:
      case AppConstants.ProductIds.CHALLENGER:
        label = 'Select your main country of residence';
        break;
      default:
        label = 'Your main country of residence?';
        break;
    }
    return label;
  },
  getTaxCountryLabel(isTrustee, isSMSF){
    var label;
    switch(this.props.productId){
      case AppConstants.ProductIds.COMMINSURE:
      case AppConstants.ProductIds.CHALLENGER:
        label = 'Select country of tax residence';
        break;
      case AppConstants.ProductIds.INVESTMENT:
        if (isTrustee || isSMSF){
          label = 'Select country of tax residence';
        }else{
          label = 'Country of tax residence, if not Australia?'
        }
        break;
      default:
        label = 'Country of tax residence, if not Australia?';
        break;
    }
    return label;
  },
  componentWillReceiveProps: function(nextProps) {
    if (this.props.productId !== nextProps.productId || this.props.accountType !== nextProps.accountType){
      this.setState(this.getInitialState());
    }
  },
  render: function () {
      var isPowerOfAttorneyDefined = this.props.data.isPowerOfAttorney !== undefined;
      var showTaxResidenceQuestion = !(this.props.data.isOtherCountryTaxResident === YesNoValues.YES &&
          this.props.data.isOtherCountryTaxResidentReadonly);
      var showCitizenshipQuestion = !(this.props.data.isCitizenOfOtherCountry === YesNoValues.YES &&
          this.props.data.isCitizenOfOtherCountryReadonly);
      const isSoleTrader = this.props.accountType === AppConstants.AccountTypeCodes.SOLE_TRADER;
      const isIndividual = this.props.accountType === AppConstants.AccountTypeCodes.INDIVIDUAL;
      const isMainInvestorInJoint = this.props.accountType === AppConstants.AccountTypeCodes.JOINT && this.props.data.id === 0;
      const isAccountDesignationNeeded = isSoleTrader || isIndividual || isMainInvestorInJoint;
      const isJoint = this.props.accountType === AppConstants.AccountTypeCodes.JOINT;
      const isSOFNeeded = (isSoleTrader || isIndividual || isJoint) && !this.state.isAnnuity;
      const isSOWNeeded = (isSoleTrader || isIndividual || isJoint) && !this.state.isAnnuity;

      return (
            <div>
                <PersonalInfo index={this.props.index}
                              data={this.props.data}
                              titleList={this.props.titleList}
                              section={this.props.section}
                              errorList={this.props.errorList}
                              isFullNameMessageHidden={this.state.isAnnuity || this.state.isTrustee || this.state.isSMSF} />
                <Address index={this.props.index}
                         data={this.props.data.addressInfo}
                         section={this.props.section}
                         errorList={this.props.errorList}
                         productId={this.props.productId} />
                <ContactDetails index={this.props.index}
                                productId={this.props.productId}
                                accountType={this.props.accountType}
                                data={this.props.data}
                                errorList={this.props.errorList}
                                section={this.props.section} />
                {this.state.isTrustee ? null : (<Tfn index={this.props.index}
                                         productId={this.props.productId}
                                         accountType={this.props.accountType}
                                         hasTfnExemption={this.props.data.hasTfnExemption}
                                         hasTfnExemptionReadonly={this.props.data.hasTfnExemptionReadonly}
                                         hasTfnExemptionRightText="optional"
                                         tfnNumber={this.props.data.tfnNumber}
                                         tfnNumberReadonly={this.props.data.tfnNumberReadonly}
                                         tfnExemptionReason={this.props.data.tfnExemptionReason}
                                         tfnExemptionReasonReadonly={this.props.data.tfnExemptionReasonReadonly}
                                         tfnExemptionList={this.props.tfnExemptionList}
                                         tfnConsentFlag={this.props.data.tfnConsentFlag}
                                         tfnWithConsent={this.props.data.tfnWithConsent}
                                         section={this.props.section}
                                         errorList={this.props.errorList} />)}
                <Residence index={this.props.index}
                           data={this.props.data}
                           type={YourDetailsConstants.ResidenceType.COUNTRY_RESIDENCE}
                           countryLabel={this.state.residenceCountryLabel}
                           section={this.props.section}
                           errorList={this.props.errorList}
                           showQuestion={false} />
                {this.props.productId ===  AppConstants.ProductIds.INVESTMENT 
                  ?<AustralianTaxResident 
                          data={this.props.data} 
                          section={this.props.section}
                          errorList = {this.props.errorList}
                          index={this.props.index} />  : null}
                {this.state.isAnnuity
                    ? <Residence index={this.props.index}
                               data={this.props.data}
                               type={YourDetailsConstants.ResidenceType.TAX_RESIDENCE}
                               countryLabel={this.state.taxCountryLabel}
                               section={this.props.section}
                               errorList={this.props.errorList} />
                    : <TaxResidence index={this.props.index}
                               data={this.props.data}
                               countryLabel={this.state.taxCountryLabel}
                               section={this.props.section}
                               errorList={this.props.errorList}
                               showQuestion={showTaxResidenceQuestion} />
                }
                <Residence index={this.props.index}
                           data={this.props.data}
                           type={YourDetailsConstants.ResidenceType.CITIZENSHIP}
                           section={this.props.section}
                           errorList={this.props.errorList}
                           showQuestion={showCitizenshipQuestion} />
                <Occupation index={this.props.index}
                            data={this.props.data}
                            section={this.props.section}
                            errorList={this.props.errorList} />
                {isSOFNeeded ? <SourceOfFund index={this.props.index}
                            data={this.props.data}
                            section={this.props.section}
                            errorList={this.props.errorList} /> : null}
                 {isSOWNeeded ? <SourceOfWealth index={this.props.index}
                            data={this.props.data}
                            section={this.props.section}
                            errorList={this.props.errorList} /> : null}            
                {isPowerOfAttorneyDefined ? <PowerOfAttorney data={this.props.data.isPowerOfAttorney} index={this.props.index} /> : null}
                {isAccountDesignationNeeded ? <AccountDesignation index={this.props.index}
                                    data={this.props.data}
                                    section={this.props.section}
                                    errorList={this.props.errorList} /> : null}
            </div>
    );
  }
});

module.exports = Investor;


// WEBPACK FOOTER //
// C:/GH/1106/advice.noa.origination/~/eslint-loader!./components/YourDetails/Investor.jsx